export const COLUMN_LOCALSTORAGE_KEY = 'assets:columns';
